// extracted by mini-css-extract-plugin
module.exports = {"fb2am7i":"fb2am7i"};